module.exports = __webpack_public_path__ + "img/4.97f03fc9.jpg";